import { motion } from "framer-motion";
import Chapter from "./Chapter";

const beats = [
  { n: "01", title: "Attach", sub: "one piece of evidence",
    body: "Upload once to a canonical topic — Access Review, Encryption, Logging. The topic is the atom of compliance." },
  { n: "02", title: "Map",    sub: "68 topics beneath 20 frameworks",
    body: "The crosswalk is mapped clause-by-clause: A.5.23 · CC6.1 · Art.32 · §164.312(a) all point at the same topic." },
  { n: "03", title: "Satisfy", sub: "every equivalent control",
    body: "The moment evidence lands, every mapped control across every enabled framework turns green — together." },
];

export default function MechanismSection() {
  return (
    <section id="mechanism" className="relative py-14 md:py-20 hairline-t">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Chapter number="02" label="The mechanism" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <motion.h2
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="font-display text-[36px] md:text-[52px] leading-[1.04] tracking-[-0.022em] text-balance"
            >
              Beneath 20 frameworks, <span className="grad-text">68 shared topics</span>.
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.55, delay: 0.08 }}
              className="mt-6 text-ink-muted text-[15px] md:text-[17px] leading-relaxed max-w-[48ch]"
            >
              The trick is the moat. Every framework — from ISO&nbsp;27001 to India's DPDP to ISO&nbsp;42001 for AI —
              descends into one canonical layer. Work the layer, not the forms.
            </motion.p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {beats.map((b, i) => (
                <motion.div
                  key={b.n}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{ duration: 0.55, delay: i * 0.09, ease: [0.22,1,0.36,1] }}
                  className="machined p-6 relative overflow-hidden group"
                >
                  <div className="flex items-baseline justify-between">
                    <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-ink-muted">STEP · {b.n}</span>
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-blue group-hover:bg-brand-indigo transition-colors" />
                  </div>
                  <h3 className="mt-6 font-display text-[26px] tracking-tight">{b.title}</h3>
                  <div className="mt-1 font-mono text-[11px] text-white/50">{b.sub}</div>
                  <p className="mt-4 text-[14px] text-ink-muted leading-relaxed">{b.body}</p>
                  <div className="absolute inset-x-0 bottom-0 h-px opacity-40" style={{ background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent)" }} />
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
